import type { SVGProps } from "react";
export interface ShareIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ShareIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ShareIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m13.098 1.878.167.02c.376.07.65.277.783.383.178.14.38.335.578.521l6.994 6.64c.306.29.585.555.799.794.22.248.44.545.57.926l.06.207a2.64 2.64 0 0 1 0 1.262l-.06.207c-.13.381-.35.677-.57.926-.214.239-.493.504-.799.794l-6.995 6.64c-.196.186-.399.38-.577.521-.152.12-.488.375-.95.403a1.62 1.62 0 0 1-1.21-.438l-.132-.14c-.298-.354-.345-.77-.362-.965-.02-.226-.019-.506-.019-.777v-3.169c-1.468.018-2.618.1-3.757.494-1.382.478-2.854 1.46-4.777 3.624a1.126 1.126 0 0 1-1.966-.747c0-3.944 1.053-7.13 3.116-9.336 1.845-1.973 4.388-3.043 7.384-3.254V4.198c0-.271-.001-.551.019-.778.017-.193.064-.61.362-.965l.132-.14c.277-.26.638-.415 1.018-.437zm.527 6.621A1.126 1.126 0 0 1 12.5 9.624c-3.015 0-5.313.92-6.866 2.581-1.093 1.17-1.885 2.78-2.261 4.862 1.198-1.008 2.336-1.66 3.51-2.066 1.834-.635 3.654-.625 5.617-.625.621 0 1.125.504 1.125 1.125v3.543l6.445-6.118c.334-.317.534-.507.67-.66.074-.082.105-.128.116-.146l.02-.12-.02-.12a1 1 0 0 0-.116-.147 13 13 0 0 0-.67-.659l-6.445-6.12z"
      />
    </svg>
  );
}
